import * as RadioGroupPrimitives from '@radix-ui/react-radio-group';
import * as React from 'react';

import { cn } from '@/lib/utils';

const RadioCardsRoot = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitives.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitives.Root
    ref={ref}
    className={cn('flex gap-1', className)}
    {...props}
  />
));
RadioCardsRoot.displayName = RadioGroupPrimitives.Root.displayName;

const RadioCardsItem = React.forwardRef<
  React.ComponentRef<typeof RadioGroupPrimitives.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitives.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitives.Item
    ref={ref}
    className={cn('cursor-pointer transition-colors', className)}
    {...props}
  />
));
RadioCardsItem.displayName = RadioGroupPrimitives.Item.displayName;

export { RadioCardsItem, RadioCardsRoot };
